import './style.scss'
import React from 'react'

export interface RadioCardProps {
    checked: boolean
    onChange: () => void
    label: React.ReactNode
    helpText?: string
    name: string
    disabled?: boolean
}

export const RadioCard: React.FC<RadioCardProps> = ({
                                                        checked, onChange, label, helpText, name, disabled,
                                                    }) => (
    <label className={`radio-card ${checked ? 'radio-card--checked' : ''} ${disabled ? 'radio-card--disabled' : ''}`}>
        <input
            type="radio"
            name={name}
            checked={checked}
            disabled={disabled}
            onChange={onChange}
        />
        <span className="radio-card__dot" />
        <span className="radio-card__label">{label}</span>
        {helpText && (
            <span className="radio-card__help" title={helpText}>
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="8" cy="8" r="6.5" stroke="#98A2B3" />
                    <path d="M6.06 6a1.94 1.94 0 1 1 2.7 1.79c-.55.24-.76.6-.76 1.05v.16" stroke="#98A2B3" strokeLinecap="round" />
                    <circle cx="8" cy="11.2" r="0.15" fill="#98A2B3" stroke="#98A2B3" />
                </svg>
            </span>
        )}
    </label>
)

export default RadioCard